import React from 'react'
import Detail from 'src/modules/ELearning/Collection/Detail'

const ElearningCollectionDetailPage = () => {
  return <Detail />
}

export default ElearningCollectionDetailPage
